module.exports = __webpack_public_path__ + "img/index_style1.e6e8fb03.jpg";